import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';
import { DateHelper } from '@hub4b/helpers/date-helper';
import { NgxMatNativeDateAdapter } from '@ngxmc/datetime-picker';

@Injectable()
export class CustomDatetimeAdapter extends NgxMatNativeDateAdapter {
    override parse(value: string): Date | null {
        try {
            let date = new Date(value);
            return new Date(new DatePipe(this.locale).transform(date, DateHelper.FRENCH_DATETIME_FORMAT));
        } catch (error) {
            console.log('format erreur');
            return null;
        }
    }

    override format(date: Date, display: string): string {
        if (display) {
            return new DatePipe(this.locale).transform(date, display);
        } else {
            return new DatePipe(this.locale).transform(date, DateHelper.FRENCH_DATETIME_FORMAT);
        }
    }
}
